"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = _interopRequireDefault(require("immutable"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _Rating = _interopRequireDefault(require("./Rating"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _RatingTypes = require("../../constants/reviews/RatingTypes");

var I18N_BASE = 'ecosystemMarketplaceCore.reviews.qualityDistribution';

var QualityDistribution = function QualityDistribution(_ref) {
  var qualityRatings = _ref.qualityRatings,
      heading = _ref.heading,
      labelSize = _ref.labelSize,
      hideIfEmptyValue = _ref.hideIfEmptyValue,
      showLabelTooltips = _ref.showLabelTooltips;
  var qualityRatingsObj = qualityRatings.toJS();

  var renderQualityRow = function renderQualityRow(type, value) {
    var rating = value === 'NaN' ? 0 : value;
    var renderedLabel = showLabelTooltips ? _react.default.createElement(_UIHelpIcon.default, {
      title: _react.default.createElement(_FormattedMessage.default, {
        message: I18N_BASE + ".tooltips." + type
      }),
      tooltipPlacement: "right"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: I18N_BASE + "." + type
    })) : _react.default.createElement(_FormattedMessage.default, {
      message: I18N_BASE + "." + type
    });
    return _react.default.createElement(_Rating.default, {
      key: type,
      type: _RatingTypes.PILL_RATING,
      label: renderedLabel,
      labelSize: labelSize,
      rating: rating
    });
  };

  return _react.default.createElement("div", null, heading && _react.default.createElement(_H.default, null, heading), Object.keys(qualityRatingsObj).map(function (axis) {
    var rating = qualityRatingsObj[axis];

    if ((rating == null || rating === 'NaN') && hideIfEmptyValue) {
      return null;
    }

    return renderQualityRow(axis, rating);
  }));
};

QualityDistribution.propTypes = {
  qualityRatings: _propTypes.default.instanceOf(_immutable.default.OrderedMap),
  heading: _propTypes.default.node,
  labelSize: _propTypes.default.string.isRequired,
  hideIfEmptyValue: _propTypes.default.bool.isRequired,
  showLabelTooltips: _propTypes.default.bool.isRequired
};
QualityDistribution.defaultProps = {
  labelSize: 'sm',
  hideIfEmptyValue: true,
  showLabelTooltips: false
};
var _default = QualityDistribution;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/QualityDistribution.js
// module id = 416
// module chunks = 209 210 211 212